/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepostNotificationActionData
 */
export interface RepostNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof RepostNotificationActionData
     */
    type: RepostNotificationActionDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RepostNotificationActionData
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RepostNotificationActionData
     */
    repostItemId: string;
}


/**
 * @export
 */
export const RepostNotificationActionDataTypeEnum = {
    Track: 'track',
    Playlist: 'playlist',
    Album: 'album'
} as const;
export type RepostNotificationActionDataTypeEnum = typeof RepostNotificationActionDataTypeEnum[keyof typeof RepostNotificationActionDataTypeEnum];


/**
 * Check if a given object implements the RepostNotificationActionData interface.
 */
export function instanceOfRepostNotificationActionData(value: object): value is RepostNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "repostItemId" in value && value["repostItemId"] !== undefined;

    return isInstance;
}

export function RepostNotificationActionDataFromJSON(json: any): RepostNotificationActionData {
    return RepostNotificationActionDataFromJSONTyped(json, false);
}

export function RepostNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'userId': json['user_id'],
        'repostItemId': json['repost_item_id'],
    };
}

export function RepostNotificationActionDataToJSON(value?: RepostNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'user_id': value.userId,
        'repost_item_id': value.repostItemId,
    };
}

